module.exports = __webpack_public_path__ + "img/symbol_0.b6a08d2f.png";